import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { phonesActionTypes } from '../reducer';

function* updatePhone() {
  yield requestSaga({
    actionType: phonesActionTypes.update,
    request: dataProvider.updateOne,
    resource: resources.phone.index,
  });
}

export default updatePhone;
